export default "__VITE_ASSET__CcIriT8o__"